import styled from 'styled-components';
import { fontAccent } from 'Styles/fonts';
import { black } from 'Styles/colors';

export const AccountGreeting = styled.div`
  ${fontAccent(20)};
  color: ${black};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default {};
